$(document).ready(function () {
    $(".block__supported-brands-list-slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: !0,
        centerPadding: "250px",
        prevArrow: $(".block__supported-brands-list-prev"),
        nextArrow: $(".block__supported-brands-list-next"),
        responsive: [
            { breakpoint: 1200, settings: { centerPadding: "150px" } },
            { breakpoint: 768, settings: { centerPadding: "0" } },
        ],
    });
});
//# sourceMappingURL=/cdn/shop/t/87/assets/supported-brands.js.map?v=177763726123243037711705552898
